export default "__VITE_ASSET__C3sbS2b3__"